import { render } from "./Listing.vue?vue&type=template&id=20248dad&scoped=true&ts=true"
import script from "./Listing.vue?vue&type=script&lang=ts"
export * from "./Listing.vue?vue&type=script&lang=ts"

import "./Listing.vue?vue&type=style&index=0&id=20248dad&scoped=true&lang=scss"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20248dad"]])

export default __exports__